<template>
  <div>
  
       <div  class="d-flex align-items-center justify-content-center " id="emptycon" v-if='!loadtest' >
            <div style="width: 100%">
             <p  class="emptytext">You have no orderes</p>

    <a href="file:///Users/mohamed/Desktop/bootstrap/meet.html" style="text-decoration: none;"><div   class="btn ordernow" >Order Now</div></a>
          </div>
          </div>
                 <div  class="d-flex align-items-center justify-content-center " id="emptycon" v-else-if='emptydata' >
            <div style="width: 100%">
             <p  class="emptytext">You have no ordered data</p>

    <a href="file:///Users/mohamed/Desktop/bootstrap/meet.html" style="text-decoration: none;"><div   class="btn ordernow" >Order Now</div></a>
          </div>
          </div>
 
<div v-else>
 

<div style="height: 100vh ;position: relative;
    overflow: scroll;
    z-index: 1000000; ">
   <div class="bghead" style="height:70px"></div>
   <p style="opacity:0;position:absolute;height:3px;overflow:hidden;top:0;left:0;z-index:-1">
{{orderdatas}}
</p>
 <div  class="bghead  " style="position:fixed;top:0;left:0;right:0;background:#fff;z-index:1000000000">
  <div class="container" style="padding: 0 7px!important">
 
<div class="p-md-0 py-md-0    p-2 py-3">
  <div class=" acthead d-flex align-items-center  py-md-3 px-3 py-2 pl-4"  >
<div style="color: #313131" class="order-md-2 headtitle">{{ info.name}}</div>
<div style="width: 35px;height: 35px;overflow: hidden;border-radius: 50%" class="order-md-1">
  <img :src=" info.logo" class="img-fluid" style="width: 100%;height: 100%;object-fit: cover;">
</div>

<div style="flex: 1;overflow: hidden; padding-left:100px;padding-right: 30px " class="order-3 botlayerinv">
  <div style="background: #f5f7fa; border-radius: 10px;border:1px solid #bfcfdc" class="d-flex align-items-center ">
  <input type="text" style="    color: #333;
    box-shadow: 0 0 0;
    border: 0;
    background: 0 0;
    outline: none;
 
    height: 40px;
    padding: 0 18px;
    padding-right: 50px;width: 100%" placeholder="Search for products"  name="">
    <i class='bx bx-search' style="margin-right: 20px;font-size: 18px;color: #808080"></i>
  </div>
</div>
<div class="d-flex align-items-center order-4 ml-auto extrahead">
   
   
  <div>
        <router-link :to="'/'+$route.params.shopname+'/bag'" style='text-decoration:none'>

    <p style="margin-bottom: 0;margin: 0 15px;color: #313131;font-size: 15px">Cart</p>
  </router-link>

  </div>



<div class="dropdown">
  
      <p   class="  dropdown-toggle" data-toggle="dropdown"style="margin-bottom: 0;margin: 0 15px;color: #313131;font-size: 15px">My Account</p>





  <div class="dropdown-menu ">
 
<div style= " " >
  <div class=" p-2  my-1  shadbox1">

        <router-link :to="'/'+$route.params.shopname+'/order'" style='text-decoration:none!important; ' class='d-flex align-items-center'>

    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px">playlist_add_check</i>
    <p style="margin-bottom: 0;font-family: 'Montserrat', sans-serif;font-weight: 400;font-size: 13px;color:#111">Orders</p>
       </router-link>

  
  </div>
  
  <div class=" p-2  my-1  shadbox1">
                <router-link  :to="'/'+$route.params.shopname+'/login'" style='text-decoration:none!important; ' class='d-flex align-items-center'>

    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px">directions_run</i>
    <p style="margin-bottom: 0;font-family: 'Montserrat', sans-serif;font-weight: 400;font-size: 13px;color:#111">Visited store</p>
 </router-link>
  
  </div>
  
    <div class="  p-2  my-1  shadbox1">
                  <router-link  :to="'/'+$route.params.shopname+'/support'" style='text-decoration:none!important; ' class='d-flex align-items-center'>

    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px">headset_mic</i>
    <p style="margin-bottom: 0;font-family: 'Montserrat', sans-serif;font-weight: 400;font-size: 13px;color:#111"> support</p>
 
  </router-link>
  </div>


   <div class=" p-2  my-1  d-flex align-items-center shadbox1"  v-if='!user' v-on:click='login'>
          

    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px ">exit_to_app</i>
    <p style="margin-bottom: 0;font-family: 'Montserrat', sans-serif;font-weight: 400;font-size: 13px;color:#111">Log in</p>
 
  
  </div>
    <div class="  p-2  my-1  shadbox1 d-flex align-items-center" style=""  v-if='user' v-on:click='logout'>
               
    <i class="material-icons" style="margin-right: 6px;color: #7e9c9a;font-size: 21px">exit_to_app</i>
    <p style="margin-bottom: 0;font-family: 'Montserrat', sans-serif;font-weight: 400;font-size: 13px;color:#111">Sign out</p>
 
 
  </div>
</div>

        
 

  </div>
</div>



 

</div>
</div>

</div>
</div>
 </div>

 <div class="px-5   align-items-center justify-content-end cathead" style="background: #fcfcfc;border-bottom: 1px solid #e5e5e5">
       <span class="cattop">Packages</span>

       <span class="cattop">Furniture</span>

       <span class="cattop">Appliances</span>

     <span class="cattop">Electronics</span>

   <span class="cattop">Fitness</span>
 </div>






<div class="container" style="padding: 0!important; "  >
  <div  style=" padding: 10px;border-radius: 5px;border-bottom-left-radius: 0;border-bottom-right-radius: 0"   class="d-md-block d-none">
 <h3 style=" color: #222;margin-left: -4px;line-height: 30px" class="cattitle mt-md-4 my-0 ">Orders ({{orderdatas.length}})</h3>

</div>
 
  <div class="row" style="padding: 0!important;margin: 0!important"   v-if='actualorders!=null'>
     <div class="col-md-4 d-md-block d-none col-12" style="padding: 0!important">
      
  
 <div style="" class="mt-md-3 mt-0 orderleft" >

   <div  style="  padding-left:4px;" class="mt-2 mb-3 d-md-none d-block"  >

<h5 >Orders ({{orderdatas.length}})</h5>
</div>
 
 <template v-for='a in   orderdatas'>
   

  <div style="" class="shadorder" v-on:click='showorder(a)'>
    <div class="d-flex ">
    <div style="background: #fab73b;color: #fff;font-weight: 700;text-transform: uppercase;padding:2px 10px;font-size: 11px;margin-left: -15px">{{a.status}}</div>
    </div>
    <div class="d-flex align-items-center justify-content-between  " style="margin-top: 10px">
      <p style="color: #000;font-size: 13px;margin: 0!important">Order #{{a.orderid}}</p>
      <p style="color: #000;font-size: 13px;margin: 0!important">₹{{a.total}}</p>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-1">
      <p style="color: #808080;font-size: 13px;margin: 0!important">{{a.items.length}} item</p>
      <p style="color: #808080;font-size: 13px;margin: 0!important">Today,11:52 AM</p>
    </div>
    
  </div>
   </template>

   
  
 </div>

  </div>
 
    <div class="col-md-4 col-12 d-md-none d-block" style="padding: 0!important"  >
      
  
 <div style="" class="mt-md-3 mt-0 orderleft" >

   <div  style="  padding-left:4px;" class="mt-2 mb-3 d-md-none d-flex align-items-center "  >
                      <i class="material-icons aricon" style="margin-right: 20px;position: relative;" >arrow_back</i> 

<h5 style="margin-bottom:0!important;font-size:20px">Orders ({{orderdatas.length}})</h5>
</div>
 




 <template v-for='a in   orderdatas'>
   

  <div style="" class="shadorder" v-on:click='showorder(a)'>
        <router-link :to="'/'+$route.params.shopname+'/orderdetails/'+a.orderid" style='text-decoration:none'>

    <div class="d-flex ">
    <div style="background: #fab73b;color: #fff;font-weight: 700;text-transform: uppercase;padding:2px 10px;font-size: 11px;margin-left: -15px">{{a.status}}</div>
    </div>
    <div class="d-flex align-items-center justify-content-between  " style="margin-top: 10px">
      <p style="color: #000;font-size: 13px;margin: 0!important">Order #{{a.orderid}}</p>
      <p style="color: #000;font-size: 13px;margin: 0!important">₹{{a.total}}</p>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-1">
      <p style="color: #808080;font-size: 13px;margin: 0!important">{{a.items.length}} item</p>
      <p style="color: #808080;font-size: 13px;margin: 0!important">Today,11:52 AM</p>
    </div>
    </router-link>
  </div>
   </template>


  
    
    
  </div>
  
 

  </div>
    <div class="col-md-8 d-md-block d-none pt-3 ">
      <div style=" padding: 15px;background:#fff;box-shadow: 0 2px 6px 0 rgba(191,207,220,.4);border-radius: 5px">

  <div style="padding: 8px">

    <div class="d-flex align-items-center justify-content-between">
      <p style="margin: 0!important;font-weight: 700">Order #8172</p>
      <div class="d-flex align-items-center">
        <div style="width: 9px;height: 9px;border-radius: 50%;background: #fab73b;margin-right: 5px"></div>
        <p style="margin: 0!important;color: #808080;margin-left: 10px">{{orderdetails.status}}</p>
      </div>
    </div>
    <p style="margin: 0;color: #808080;font-weight: 300;" class="mt-2">Today, 11:52 AM</p>
    <div style="height: 1px;background: #f5f7fa;margin-top: 16px;"></div>
    <p style="color: #808080;text-transform: uppercase;margin-top: 14px;font-size: 13px;letter-spacing: 0.3px">{{orderdetails.items.length}} Item</p>
    <div>


      <template v-for='itm in orderdetails.items'>
        

  
      <div class="d-flex align-items-start  mb-3">
        <div style="width: 75px;border-radius: 5px;overflow: hidden;">
          <img :src="itm.imageurl" class="img-fluid">
        </div>
        <div style="flex: 1;padding: 5px 13px">
          <p  style="margin-bottom: 10px;font-size: 16px">{{itm.name}}</p>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center ">
              <div style="width: 21px;height: 21px;border-radius: 3px;border:1px solid #7e9c9a" class="d-flex align-items-center justify-content-center">
                <span>{{itm.quantity}}</span>
              </div>
              <span style="margin: 0 9px">x</span>
              <span>₹{{itm.price}}.0</span>
            </div>
            <span>₹{{itm.price}}.0</span>
          </div>
        </div>
        
      </div>
          </template>
       
    </div>
        <div style="height: 1px;background: #f5f7fa;margin-top: 20px;"></div>
         <div style="padding: 0 0px">

          <div style="font-weight: 500;
    font-size: 13px;
    margin-bottom: 10px;
    color: #5d5b5b;letter-spacing: 0;margin-top: 16px" id="billdetails">Bill Details</div>
    <div class="d-flex justify-content-between">
      <span style="font-size: 13px;
    color: #313131;font-weight: 300;">Item Total</span>
      <span style="font-size: 13px;  
    color: #313131;font-weight: 300;" id="itmtot">₹{{orderdetails.total}}</span>
    </div>

 <div class="d-flex justify-content-between mt-2 ">
      <span style="font-size: 13px;
    color: #313131;font-weight: 300;">Delivery Fee</span>
      <span style="font-size: 13px;
    color: #313131;font-weight: 300;" id="delcharge" data-delcharge=39>₹39</span>
    </div>

 
     <div class="d-flex justify-content-between    " style=" padding-top: 15px; padding-bottom: 10px ">
      <span style="font-size: 13.5px;
    color: #000;  font-weight: 700;
text-transform: uppercase;">Grand total</span>
      <span style="font-size: 13.5px;
    color: #686b78;    font-weight: 700;
    color: #000;" id="totalpay">₹{{orderdetails.total + 39}}</span>
    </div>

</div>

        <div style="height: 1px;background: #f5f7fa;margin-top: 15px;"></div>
        <div>
          
          <div style="font-weight: 500;
    font-size: 13px;
    margin-bottom: 10px;
    color: #5d5b5b;letter-spacing: 0;margin-top: 16px" id="billdetails">Contact Details</div>
    <div class="d-flex align-items-center mb-2">
      <div style="width: 120px;">
        <p style="color: #000;margin:0">Name:</p>
      </div>
      <p style="color: #808080;margin: 0">{{orderdetails.name}}</p>
      
    </div>
     <div class="d-flex align-items-center mb-2">
      <div style="width: 120px;">
        <p style="color: #000;margin:0">Mobile:</p>
      </div>
      <p style="color: #808080;margin: 0">{{orderdetails.mobile}}</p>
      
    </div>
     <div class="d-flex align-items-center mb-2">
      <div style="width: 120px;">
        <p style="color: #000;margin:0">Address:</p>
      </div>
      <p style="color: #808080;margin: 0">{{orderdetails.address}}</p>
      
    </div>
     <div class="d-flex align-items-center mb-2">
      <div style="width: 120px;">
        <p style="color: #000;margin:0">City:</p>
      </div>
      <p style="color: #808080;margin: 0">{{orderdetails.city}}</p>
      
    </div>
        </div>

    <div style="height: 60px"></div>
  </div>
 
</div>
 

      <div>
        
      </div>
      
    </div>
  </div>
</div>
 

<div style="height: 30px" class="d-md-block d-none"></div>
</div>
</div>
 </div>


     </div>
</template>

<script>
 
 import firebase from 'firebase'
var z=[]
 
const fb = require('./firebaseconfig.js')
export default {

       props: ['loadstatus','info','products','category','deals','addcart','test','cart','carts' ],

      data () {

        return{

            orderdetails:null,
            actualorders:null,
            user:false,orderstest:[],
            loadtest:false,
            emptydata:false,
          from:null


        }
      
      },
     
  created(){

alert('s')

var vm=this



     fb.db.collection('shopusers').doc(firebase.auth().currentUser.uid).collection('orders').orderBy('date','desc').onSnapshot(querySnapshot=>{
 z=[]
    querySnapshot.forEach((doc)=> {
      
 
      z.push(doc.data())
        
    })
 
 console.log(z[z.length-1])
 var zz=z[z.length-1]
 
vm.$emit('setorder', z)

 
    vm.orderstest=[

    ...z

    ]

 

 vm.loadtest=true
 if(vm.orderstest.length>0){
vm.emptydata=false
 }else{
   vm.emptydata=true
 }

 
 


  })




     if(firebase.auth().currentUser){






  this.user=true
 }else{
    this.user=false
 }





   },

 
   methods:{
      account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/'+this.$route.params.shopname+'/account' })

 }else{
this.loginbox=true
 }
    },
    
    login(){

  this.$router.push({ path: '/'+this.$route.params.shopname+'/login',query:{refer:'/'+this.$route.params.shopname+'/order'} })

},

         logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 alert('signed out successfully')

vm.$router.replace({ path: '/'+vm.$route.params.shopname })

vm.user=false
}).catch(function(error) {
 
});
      },
      showorder(orders){
        
         this.orderdetails=orders
         console.log(this.orderdetails)


      }

   },
   computed:{

 rendercartlength(){

var cartlength=0
        var x=this.carts.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },
orderdatas(){
 
 
 
if(!this.orderstest.length){
 alert('aaa')

 this.actualorders=null
    this.orderdetails=null
}else{

 

 this.actualorders=this.orderstest
    this.orderdetails=this.orderstest[0]
}

   
    return this.actualorders
  }
  }
 

   
    
 
  
}
</script>
<style  scoped>

 
  #emptycon{

  width: 100%;height: 100vh;background:#fff; text-align: center; 
 }
   
 /*
for category
 */
 .maincon{
  box-shadow: 0 1px 2px 0 #bfcfdc;
    background: #fff;
    border-radius: 5px;
  
 }
 .image{
  border-bottom-left-radius: 19px;
  border-bottom-right-radius: 19px;overflow: hidden;
  }

  .image img{
    width: 55px;height: 55px;border-radius: 50%;
    margin : 15px 0;
    margin-bottom: 7px;
     box-shadow: 0 4px 10px 0 rgba(191,207,220,.4);
  }
 .content{
  font-size: 12px;
    color: #313131;
    margin: 0;
    font-weight: 500;
    white-space: nowrap;
    padding: 4px 3px
 }
 .padle{
  padding: 0 9px!important;text-align: center;
 }
 


 .cattitle{
  color: #313131;
  
  font-size: 25px;
      font-weight: 400;padding-left: 12px
 }


 /*
for deals of the day
 */

 .maincon2{
     
  
    padding: 10px;
        background: #fff;
    border: 1px solid #e2eaf0;
    border-radius: 2px;
  
 }
 

  .image2 img{
   width: 100%
   }
 .content2 h4{
   color: #313131;font-size: 12px;
   margin-bottom: 0!important;
   margin: 9px 0
 }
  .content2 h3{
    font-size: 12px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }

.arrows{
      width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none!important;
 
}
  
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: 'next';
    display: none;
}
.swiper-button-next, .swiper-button-prev {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin-top: 0
}
 
 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right:auto;
    left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: auto;
    right: auto;
}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: 'prev';
    display: none;
}

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}

 .maincon2{
     
  
    padding: 10px;
        background: #fff;
     box-shadow: 0 1px 5px  rgba(0,0,0,.1);
        border-radius: 2px;
  
 }
 

  .image2 img{
   width: 100%
   }
 .content2 h4{
   color: #313131;font-size: 14px;
   margin-bottom: 0!important;
   margin: 9px 0;
       padding-left: 5px;
 }
  .content2 h3{
    font-size: 15px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    margin: 8px 0;
    padding-left: 5px;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }

.arrows{
      width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none!important;
 
}
  
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: 'next';
    display: none;
}
.swiper-button-next, .swiper-button-prev {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin-top: 0;
    margin: 0 7px
}
 
 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right:auto;
    left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: auto;
    right: auto;
}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: 'prev';
    display: none;
}

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}
.bghead{
  background: #fff;
}
.acthead{
  background: #fff;
    padding: 15px;
    
    border-radius: 4px;
    margin: 0 -10px;
    justify-content: flex-start;
}
.headtitle{
  font-size: 25px;margin-left: 15px
}
.categoryhead{

  background: #f5f7fa
}

.categoryhead .container{

padding:  0 16px
}
.dealcon{
  background: #fff
}
 .botcon .container .con{
  background: #f5f7fa
}
.social{

  width: 30px;height: 30px;border-radius: 50%;box-shadow: 0 0 4px rgba(0,0,0,0.3);display: flex;
  align-items: center;justify-content: center;margin: 0 5px;background: #fff
}
.social i{
  font-size: 20px
}
.forbotmob{
  display: none;
}
.botlayer{
  display: none;
}
.botlayerinv{
 display: block;
}
.orderleft{
  background: #fff;border-radius: 6px;
  padding: 15px;box-shadow: 0 2px 6px 0 rgba(191,207,220,.4)
}
.shadorder{
  background: #fff;padding: 10px 15px;border-radius: 4px;box-shadow:none;margin-bottom: 10px;
  border-bottom: 1px solid #f5f7fa
}

.cathead{
  display: flex;
}

.cattop{
      color: #717171;
    font-size: 13px;
    font-weight: 300;padding: 15px 20px
}
@media (max-width: 992px) {
   .container{
      width: 100%;
      max-width: none;
      padding-left: 30px!important;
      padding-right: 30px!important

   }


}
@media (max-width: 760px) {

.shadorder{
  background: #fff;padding: 10px 15px;border-radius: 4px;box-shadow: 0 2px 6px 0 rgba(191,207,220,.4);margin-bottom: 10px;border:0;
}
  .orderleft{
  background:transparent;border-radius: 0px;
  padding: 15px;box-shadow:none;
}
.swiper-button-next, .swiper-button-prev {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin : 0
}
  .container{
      width: 100%;
      max-width: none;
      padding-left:16px!important;
      padding-right:16px!important

   }

.cathead{
  display: none;
}
 
.botlayer{
  display:block;
}
.botlayerinv{
  display: none!important;
}
.forbotpc{
  display: none;
}
.forbotmob{
  display: block;
}
 .content2 h4{
   color: #313131;font-size: 12px;
   margin-bottom: 0!important;
   margin: 9px 0
 }
  .content2 h3{
    font-size: 12px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }
 .maincon2{
     
  
    padding: 10px;
        background: #fff;
    border: 1px solid #e2eaf0;
    border-radius: 2px;
    box-shadow: none
  
 }

.dealcon{
  background: #f5f7fa
}
.acthead{
  background: #fff;
    padding: 15px;
    box-shadow: 0 2px 6px 0 rgba(191,207,220,.4);
    border-radius: 4px;
    justify-content: space-between;
     margin: 0!important
}
.bghead{
    display: none;
  background: transparent;
}

 .maincon{
  box-shadow: 0 1px 2px 0 #bfcfdc;
    background: #fff;
    border-radius: 5px;
    border:0
  
 }
 .categoryhead .container{

padding:  auto;
}
.headtitle{
  font-size: 15px;margin-left: 0px
}
.extrahead{
  display: none!important;
}
  .image img{
    width: 55px;height: 55px;border-radius: 50%;
    margin : 15px 0;
    margin-bottom: 7px;
     box-shadow: 0 4px 10px 0 rgba(191,207,220,.4);
  }
  .categoryhead{

  background: transparent;
}
 .cattitle{
  color: #313131;
  font-size: 14px;
  
      font-weight: 400;
 }
  .content{
    font-size: 14px;
  font-size: 12px;
    color: #313131;
    margin: 0;
    font-weight: 500;
    white-space: nowrap;
    padding: 4px 3px!important
 }

}
 .maincon2{
     
  
    padding: 10px;
        background: #fff;
    border: 1px solid #e2eaf0;
    border-radius: 2px;
  
 }
 

  .image2 img{
   width: 100%
   }
 .content2 h4{
   color: #313131;font-size: 12px;
   margin-bottom: 0!important;
   margin: 9px 0
 }
  .content2 h3{
    font-size: 12px;
    line-height: 17px;
    margin: 5px 0;
    color: #333;
    
  
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    -webkit-font-smoothing:auto;
  }

.arrows{
      width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none!important;
 
}
  
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: 'next';
    display: none;
}
.swiper-button-next, .swiper-button-prev {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #313131;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;top: 0;
    margin-top: 0
}
 
 .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right:auto;
    left: auto;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: auto;
    right: auto;
}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
    content: 'prev';
    display: none;
}

.navclass{
      padding: 5px 10px;
    border-radius: 20px;
}

</style>
 



// WEBPACK FOOTER //
// src/order.vue